import PropTypes from 'prop-types';

import './LinkList.scss';

const LinkList = ({ className = '', list }) => (
  <ul className={`link-list ${className}`}>
    {Array.isArray(list) &&
      list.map(({ id, title, url }) => (
        <li key={id}>
          <a href={url}>{title}</a>
        </li>
      ))}
  </ul>
);

LinkList.propTypes = {
  className: PropTypes.string,
  list: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      title: PropTypes.string,
      url: PropTypes.string
    })
  ).isRequired
};

export default LinkList;
